export const INBOUND_ACTION_TYPES = {
  LIST_BRANCH: 'LIST_BRANCH',
  ENROLLMENT: 'ENROLLMENT',
  GOAL_CRITERIA: 'GOAL_CRITERIA'
};
export const INBOUND_REFERENCE_SOURCE_TYPES = {
  FLOW: 'FLOW',
  CLASSIC_LIST: 'CLASSIC_LIST',
  LIST: 'LIST',
  ACTION: 'ACTION'
};
export const SUPPRESSION_REFERENCE_ACTION_TYPE = 'SUPPRESSION';
export const OUTBOUND_REFERENCE_TYPES = {
  CLASSIC_LIST: 'CLASSIC_LIST',
  LIST: 'LIST',
  CRM_USAGE: 'CRM_USAGE'
};
export const OUTBOUND_ASSET_TYPES = {
  AUTOMATION_PLATFORM_FLOW: 'AUTOMATION_PLATFORM_FLOW',
  WORKFLOW: 'WORKFLOW',
  EMAIL: 'EMAIL',
  USER: 'USER',
  TEAM: 'TEAM',
  INTEGRATION: 'INTEGRATION',
  FORM: 'FORM',
  PROPERTY: 'PROPERTY',
  FEEDBACK_SURVEY: 'FEEDBACK_SURVEY'
};